import {createSlice} from "@reduxjs/toolkit";

export const unitySlice = createSlice({
    name: "unity",
    initialState: {
        value: false,
        applicationVersion: null,
        isLatestVersion: true,
        versionInfo: {
            version: null,
            releaseNotes: null,
            downloadLink: null,
            identifier: null
        }
    },
    reducers: {
        setUnity: (state, action) => {
            state.value = action.payload;
        },
        setApplicationVersion: (state, action) => {
            state.applicationVersion = action.payload;
        },
        setIsLatestVersion: (state, action) => {
            state.isLatestVersion = action.payload;
        },
        setApplicationVersionInfo: (state, action) => {
            state.versionInfo = action.payload;
        }
    },
});

export const {setUnity, setApplicationVersion, setIsLatestVersion, setApplicationVersionInfo} = unitySlice.actions;

export const selectUnity = (state) => state.OpenInUnity.value;
export const selectApplicationVersion = (state) => state.OpenInUnity.applicationVersion;
export const selectIsLatestVersion = (state) => state.OpenInUnity.isLatestVersion;
export const selectApplicationVersionInfo = (state) => state.OpenInUnity.versionInfo;

export default unitySlice.reducer;

